import { createContext, useContext } from "react";

/** Printing expands branches without changing the provider's interactive view. */
export const CarePlanPrintContext = createContext(false);

export function useCarePlanPrint() {
  return useContext(CarePlanPrintContext);
}
